import { encodeParams } from 'mailup-react-helpers'

import apiWrapper from 'Helpers/apiWrapper'

import type {
  CanCreateAutomationResponse,
  CopyWorkflowResponse,
  DeleteWorkflowResponse,
  PagedListWorkflowItems,
  SearchWorkflowsInputData,
  SetEnableWorkflowResponse,
  WorkflowItem,
  WorkflowSimulateResponse,
} from 'Types/beAutomationApi'

const endpoints = ((baseURL: string) => {
  return {
    //  Workflows
    getAutomationWorkflow: (idWorkflow: number) =>
      `${baseURL}/api/workflow/${idWorkflow}`,
    copyWorkflow: (idWorkflow: number) =>
      `${baseURL}/api/workflow/${idWorkflow}/copy`,
    deleteWorkflow: (idWorkflow: number) =>
      `${baseURL}/api/workflow/${idWorkflow}/delete`,
    searchWorkflows: (idList: number, qsParams: any) =>
      `${baseURL}/api/list/${idList}/workflows?${
        encodeParams(qsParams) as string
      }`,
    setEnableWorkflow: (idWorkflow: number) =>
      `${baseURL}/api/workflow/${idWorkflow}/enable/set`,
    simulateWorkflow: (idWorkflow: number) =>
      `${baseURL}/api/workflow/${idWorkflow}/simulate`,

    //  Checks
    canCreateAutomation: `${baseURL}/api/automation/cancreate`,
  }
})(process.env.BEAUTOMATION_URL as string)

export const beAutomationApiGetAutomationWorkflow = async (
  idWorkflow: number,
): Promise<WorkflowItem> => {
  return await apiWrapper({
    url: endpoints.getAutomationWorkflow(idWorkflow),
  }).then(({ data }) => data)
}

export const beAutomationApiSearchWorkflows = async (
  idList: number,
  qsParams: any,
  dataIn: SearchWorkflowsInputData,
): Promise<PagedListWorkflowItems> => {
  return await apiWrapper({
    method: 'post',
    url: endpoints.searchWorkflows(idList, qsParams),
    headers: {
      'Content-Type': 'application/json',
    },
    data: JSON.stringify(dataIn),
  }).then(({ data }) => data)
}

export const beAutomationApiCanCreateAutomation =
  async (): Promise<CanCreateAutomationResponse> => {
    return await apiWrapper({
      url: endpoints.canCreateAutomation,
    }).then(({ data }) => data)
  }

export const beAutomationApiCopyWorkflow = async (
  idWorkflow: number,
): Promise<CopyWorkflowResponse> => {
  return await apiWrapper({
    method: 'post',
    url: endpoints.copyWorkflow(idWorkflow),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(({ data }) => data)
}

export const beAutomationApiSimulateWorkflow = async (
  idWorkflow: number,
): Promise<WorkflowSimulateResponse> => {
  return await apiWrapper({
    method: 'post',
    url: endpoints.simulateWorkflow(idWorkflow),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(({ data }) => data)
}

export const beAutomationApiDeleteWorkflow = async (
  idWorkflow: number,
): Promise<DeleteWorkflowResponse> => {
  return await apiWrapper({
    method: 'delete',
    url: endpoints.deleteWorkflow(idWorkflow),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(({ data }) => data)
}

export const beAutomationApiSetEnableWorkflow = async (
  idWorkflow: number,
  status: boolean,
): Promise<SetEnableWorkflowResponse> => {
  return await apiWrapper({
    method: 'put',
    url: endpoints.setEnableWorkflow(idWorkflow),
    headers: {
      'Content-Type': 'application/json',
    },
    data: JSON.stringify({
      Enable: status,
    }),
  }).then(({ data }) => data)
}
